import { EMPTY } from 'rxjs';
import { mergeMap, withLatestFrom } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { LpAdaptersTranslator, DEMO_CBRIDGE_ADAPTER } from '@cbridge-packages/lp-adapters';
import { ClientLpAction } from '../clientLp.action';
import { clientLpStoreSelector } from '../clientLp.selector';

type IState = IGetSelectorStateType<typeof clientLpStoreSelector>;
type IDependencies = IClientApiDependencySegment;

export const loadClientLpAdapterSchemaEpic: IEpic<IState, IDependencies> = (action$, state$, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(ClientLpAction.loadAdapterSchema.started),
  withLatestFrom(state$),
  mergeMap(([params, state]) => {
    const adapterSchemas = clientLpStoreSelector(state).adapterSchemas ?? {};

    // The demo adapter is preconfigured on the CP side and has no schema.
    if (!params.adapterName || params.adapterName === DEMO_CBRIDGE_ADAPTER || params.adapterName in adapterSchemas) {
      return EMPTY;
    }

    return dependencies.api.getLpAdapterSchema({ adapterName: params.adapterName }).pipe(
      mergeMap((response) => {
        const schemas = LpAdaptersTranslator.fromApiSchemas(response);

        return schemas
          ? [ClientLpAction.loadAdapterSchema.done({ params, result: schemas })]
          : [ClientLpAction.loadAdapterSchema.failed({ params, error: null })];
      }),
      // 404 (adapter has no schema in CP) is a legitimate case: fall back to
      // the plain read-only settings grid silently. Real failures are surfaced.
      catchApiError((error) => (error.status === 404
        ? [ClientLpAction.loadAdapterSchema.failed({ params, error: null })]
        : [
          ClientLpAction.loadAdapterSchema.failed({ params, error: null }),
          createApiErrorNotification(error),
        ])),
    );
  }),
);
